import { useEffect } from 'react'

import {
  getPatchReceptionCallHistoryByMeetingIdMutationKey,
  usePatchReceptionCallHistoryByMeetingId,
} from '@reception-web/common/api/www'
import {
  HISTORY_CALLER_STATUS,
  HISTORY_RECEIVER_STATUS,
} from '@reception-web/common/consts'
import { useTranslation } from 'react-i18next'
import { MdLogout } from 'react-icons/md'

import { Button, Text } from '../../components'
import ChatComponent from '../../components/guest/ChatComponent'
import MeetingComponent from '../../components/guest/MeetingComponent'
import {
  useAttendeePresenceListener,
  useDeviceIdProvider,
  useMeeting,
  useMeetingContext,
  useMessaging,
} from '../../hooks'

export function MeetingFrame() {
  const { leaveMeeting } = useMeeting()
  const { deviceId } = useDeviceIdProvider()
  const { messages, message, setMessage, sendMessage } = useMessaging()
  const { meeting, setMeeting, setAttendee, attendee, isRedial, setIsRedial } =
    useMeetingContext()

  async function onLeave() {
    const status = isRedial
      ? {
          receiver_status: HISTORY_RECEIVER_STATUS.THE_CALL_FINISHED_NORMALLY,
        }
      : {
          caller_status: HISTORY_CALLER_STATUS.THE_CALL_FINISHED_NORMALLY,
        }

    if (deviceId && meeting?.MeetingId) {
      await changeStatus({
        ...status,
        finished: new Date().toISOString(),
      })
    }
    // Clear meeting and attendee
    setMeeting(undefined)
    setAttendee(undefined)
    setIsRedial(false)
  }

  useAttendeePresenceListener({
    selfId: attendee?.AttendeeId ?? '',
    onLeave,
  })
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'frames.MeetingFrame')
  const en = i18n.getFixedT('en', 'translation', 'frames.MeetingFrame')
  const { trigger: changeStatus } = usePatchReceptionCallHistoryByMeetingId(
    deviceId ?? '',
    meeting?.MeetingId ?? '',
    {
      swr: {
        swrKey: getPatchReceptionCallHistoryByMeetingIdMutationKey(
          deviceId ?? '',
          meeting?.MeetingId ?? ''
        )[0],
      },
    }
  )

  useEffect(() => {
    if (!meeting || !attendee) {
      leaveMeeting()
    }
  }, [meeting, attendee, leaveMeeting])

  return (
    <div className="h-screen bg-off-white p-[60px] wide:p-[30px]">
      <div className="flex flex-col items-center gap-10 wide:gap-2">
        <div className="flex h-[75vh] w-full items-center wide:h-[80vh]">
          <MeetingComponent />
          <ChatComponent
            messages={messages}
            message={message}
            setMessage={setMessage}
            sendMessage={sendMessage}
          />
        </div>
        <Button
          className="mt-4 h-[50px] w-[300px]"
          size="l"
          square
          fill
          onClick={onLeave}
        >
          <div className="flex items-center justify-center gap-2">
            <Text weight="normal" align="center">
              {ja('end')}
              <br />
              {en('end')}
            </Text>
            <MdLogout size={20} />
          </div>
        </Button>
      </div>
    </div>
  )
}
